(function() {
    var callbacksHandled = [];
    var handleCallback = function(callback) {
        if (callbacksHandled.indexOf(callback) > -1) return;

        callback();
        callbacksHandled.push(callback);
    };

    var domIsReady = function() {
        return /complete|interactive|loaded/.test(document.readyState);
    };

    var customerExistsInWindow = function() {
        return ('customer' in window.CF);
    };

    var embedFormHasMounted = function() {
        return !!document.querySelector('.cf-form-inner');
    };

    var customerReady = function(callback) {
        if (customerExistsInWindow()) {
            handleCallback(callback);
        } else {
            var createListener = function() {
                document.addEventListener("cf:customer_ready", function() {
                    handleCallback(callback);
                });
            };

            if (domIsReady()) {
                createListener();
            } else {
                document.addEventListener("DOMContentLoaded", function() {
                    if (customerExistsInWindow()) {
                        handleCallback(callback);
                    } else {
                        createListener();
                    }
                });
            }
        }
    }

    var formsReady = function(callback) {
        if (embedFormHasMounted()) {
            handleCallback(callback);
        } else {
            var createListener = function() {
                document.addEventListener("cf:ready", function() {
                    handleCallback(callback);
                });
            };

            if (domIsReady()) {
                createListener();
            } else {
                document.addEventListener("DOMContentLoaded", function() {
                    if (embedFormHasMounted()) {
                        handleCallback(callback);
                    } else {
                        createListener();
                    }
                });
            }
        }
    };

    if (window.CF) {
        window.CF.customerReady = customerReady;
        window.CF.ready = formsReady;
    } else {
        window.CF = {
            customerReady: customerReady,
            ready: formsReady,
        };
    }
})();
